/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {DeleteCommentMutation, DeleteCommentMutationVariables} from '../types';

export const DeleteCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode;
/** hook для мутации "DeleteComment" */
export function useDeleteCommentMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        DeleteCommentMutation,
        DeleteCommentMutationVariables        
    >,
) {
    return ApolloReactHooks.useMutation<
    DeleteCommentMutation,
    DeleteCommentMutationVariables
    >(DeleteCommentDocument, baseOptions ?? ({} as ApolloReactHooks.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>));
}
